import React from "react";

import { Box, styled } from "@mui/material";
import { useUserDataContext } from "context/UserDataContext";
import { SubscriptionType } from "types/enums";
import { isAtTierOrHigher } from "utils";

interface IProps {
  children: React.ReactNode;
  isNotPremium?: boolean;
}

const Wrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isNotPremium",
})<Pick<IProps, "isNotPremium">>(({ isNotPremium }) => ({
  display: "inline-block",
  position: "relative",
  ...(isNotPremium && {
    filter: "blur(8px)",
    pointerEvents: "none",
    userSelect: "none",
  }),
  transition: "filter 0.3s",
}));

const BlurredOverlay = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#888",
  fontWeight: 600,
  fontSize: "1rem",
  pointerEvents: "none",
  zIndex: 1,
});

interface IProps {
  children: React.ReactNode;
}

const PremiumBlurWrapper = ({ children }: IProps) => {
  const { subscriptionType } = useUserDataContext();
  const isNotPremium = !isAtTierOrHigher(subscriptionType ?? SubscriptionType.FREE, SubscriptionType.PREMIUM);

  return (
    <Wrapper isNotPremium={isNotPremium}>
      {children}
      {isNotPremium && <BlurredOverlay />}
    </Wrapper>
  );
};

export default PremiumBlurWrapper;
